import { canUseDOM } from '.';

export const inIframe = () => (canUseDOM ? window.self !== window.top : false);
